export const initBlockData = {
  title: "Lux Express operates in 7 countries",
  content1:
    "<p>Busy schedule, convenient connections and comfortable coaches to explore our wide network of destinations.</p>",
  image: {
    src: "",
    alt: "",
  },
  blockBackgroundImage: "",
  blockBackgroundImageMobile: "",
  link: "",
  showMore: {
    link: '/',
    text: 'Show more',
  }
};

export const initEmptyBlockData = {
  title: "",
  content1: "",
  image: {
    src: "",
    alt: "",
  },
  blockBackgroundImage: "",
  blockBackgroundImageMobile: "",
  link: "",
  showMore: {
    link: '/',
    text: 'Show more',
  }
};
